import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

const Navbar = () => {
  const { lang, setLang, t } = useLanguage();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center gap-3">
          <img src="/assets/fc-logo.webp" alt="FC — Fabio Comelli" className="h-9 w-9" />
        </Link>
        <nav className="hidden items-center gap-10 font-mono text-xs uppercase tracking-[0.2em] text-muted2 md:flex">
          <Link to="/#apps" data-testid="nav-apps-link" className="transition-colors duration-300 hover:text-neon">{t.nav.apps}</Link>
          <Link to="/#manifesto" data-testid="nav-manifesto-link" className="transition-colors duration-300 hover:text-neon">{t.nav.manifesto}</Link>
          <Link to="/oltre" data-testid="nav-beyond-link" className="transition-colors duration-300 hover:text-neon">{t.nav.beyond}</Link>
          <Link to="/#contact" data-testid="nav-contact-link" className="transition-colors duration-300 hover:text-neon">{t.nav.contact}</Link>
        </nav>
        <div className="flex items-center gap-1 rounded-full border border-white/15 p-1" data-testid="lang-switcher">
          {["it", "en"].map((l) => (
            <button
              key={l}
              data-testid={`lang-toggle-${l}`}
              onClick={() => setLang(l)}
              className={`rounded-full px-3 py-1 font-mono text-[11px] uppercase tracking-widest transition-colors duration-300 ${
                lang === l ? "bg-neon text-black" : "text-muted2 hover:text-white"
              }`}
            >
              {l}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
